import { Tooltip } from "@heroui/react";
import React, { type FC, memo } from "react";
import { FormattedMessage } from "react-intl";

import { DmsUtils } from "@dms/scripts/utils/DmsUtils";
import { DmsTypeOptions } from "@dms/configs/constants";
import type { GQL } from "@binale-tech/shared";

import { CircleInfo } from "@gravity-ui/icons";

interface IProps {
    document: GQL.IDocument;
    fileName: string;
}

export const FilesExistingItem: FC<IProps> = memo(({ document, fileName }) => {
    const { type, createdBy, createdAt, updatedAt } = document;

    const finedTypeInfo = DmsTypeOptions.find((el) => el.value === type);
    const status = DmsUtils.getDocumentStatus(document);

    const fileInfo = (
        <div className="flex flex-col gap-2">
            {finedTypeInfo && (
                <div className="flex flex-col">
                    <span className="font-semibold text-white">
                        <FormattedMessage id="app.dms.fileInfo.documentType" />:
                    </span>
                    <span className="text-white">
                        {finedTypeInfo.translationKey ? (
                            <FormattedMessage id={finedTypeInfo.translationKey} />
                        ) : (
                            finedTypeInfo?.value
                        )}
                    </span>
                </div>
            )}

            <div className="flex flex-col">
                <span className="font-semibold text-white">
                    <FormattedMessage id="app.dms.createdBy" />:
                </span>
                <span className="text-white">{createdBy?.email}</span>
            </div>

            <div className="flex flex-col">
                <span className="font-semibold text-white">
                    <FormattedMessage id="app.dms.fileInfo.uploadedAt" />:
                </span>
                <span className="text-white">{createdAt}</span>
                {createdAt !== updatedAt && (
                    <span className="text-white">
                        {createdAt} {updatedAt}
                    </span>
                )}
            </div>

            <div className="flex flex-col">
                <span className="font-semibold text-white">
                    <FormattedMessage id="app.dms.status" />:
                </span>
                <span className="text-white">{status}</span>
            </div>
        </div>
    );

    return (
        <div className="flex gap-2 w-full items-center">
            <Tooltip delay={0} closeDelay={0}>
                <Tooltip.Trigger>
                    <CircleInfo className="cursor-pointer size-4" />
                </Tooltip.Trigger>
                <Tooltip.Content placement="left top">{fileInfo}</Tooltip.Content>
            </Tooltip>
            <strong>{fileName}</strong>
        </div>
    );
});
